import sha1 from "js-sha1"

//随机数helper
function randomHelper(times) {
  let num = ""
  for (let i = 0; i < times; i++) {
    num += Math.floor(Math.random() * 10)
  }
  return num
}

// 请求头添加数字签名
function customizeHeaders(url, params, method) {
  // 无数字签名
  // if (!sessionStorage.getItem("userInfo")) return {}
  // get条件下拼接query
  let queryString = ""
  if (method === "get" && params) {
    queryString = Object.keys(params)
      .map((key) => key + "=" + params[key])
      .join("&")
    queryString = "?" + queryString
  }
  const userInfo = JSON.parse(sessionStorage.getItem("userInfo"))
  // let userInfo = {
  //   access_token: "120f251c-7389-428d-9673-342cb475c7e9",
  //   sessionid: "c5132ac6-fd56-4534-8fac-27a7dd837e16",
  // }

  const nonce = randomHelper(6)
  const timestamp = new Date().getTime()
  const sha1Str = `access_token=${userInfo.access_token}&nonce=${nonce}&timestamp=${timestamp}&url=${url}${queryString}`
  const signature = sha1(sha1Str).toString()
  return {
    nonce: nonce,
    signature: signature,
    timestamp: timestamp,
    sessionid: userInfo.sessionid,
  }
}

//获取url的query值
function getQueryStringValue(url, key) {
  return decodeURIComponent(
    url.replace(
      new RegExp(
        "^(?:.*[&\\?]" +
          encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") +
          "(?:\\=([^&]*))?)?.*$",
        "i"
      ),
      "$1"
    )
  )
}

// 微信二次分享问题
function removeWechatPostfix() {
  const fromIdx = window.location.href.indexOf("from")
  if (fromIdx > -1) {
    const newUrl = window.location.href.slice(0, fromIdx - 1)
    window.location.replace(newUrl)
  }
}

// 获取query
function getKey(key) {
  if (window.location.href.indexOf(key) === -1) return null
  const hashIdx = window.location.href.indexOf("#")
  let newUrl = window.location.href
  if (hashIdx > -1) {
    newUrl = window.location.href.slice(0, hashIdx)
  }
  const id = getQueryStringValue(newUrl, key)
  return id
}

export { customizeHeaders, removeWechatPostfix, getKey }
